export default class formConfig {
  // 企业登记信息-详情
  static configList() {
    return [
      {
        title: "基本信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "企业名称：",
            value: "corpName",
            type: "input",
            disabled: true,
            width: "50%"
          },
          {
            label: "社会信用代码：",
            value: "corpCode",
            type: "input",
            tip: "(组织机构代码)",
            disabled: true,
            width: "50%"
          }
        ]
      },
      {
        title: "基本信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "资质资格类型：",
            value: "certTypeNum",
            type: "slot",
            slotName: "certTypeNum",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择资质资格类型",
              trigger: "change"
            }
          },
          {
            label: "证书编号：",
            value: "certId",
            type: "input",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入证书编号",
              trigger: "blur"
            }
          },
          {
            label: "资质资格最高等级：",
            value: "titleLevelNum",
            type: "slot",
            slotName: "titleLevelNum",
            disabled: false,
            optionData: [{ name: "无", value: "" }]
          }
        ]
      },
      {
        title: "证书信息",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "发证机关：",
            value: "organName",
            type: "input",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入发证机关",
              trigger: "blur"
            }
          },
          {
            label: "证书状态：",
            value: "isValid",
            type: "slot",
            slotName: "isValid",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择证书状态",
              trigger: "change"
            }
          },
          {
            label: "发证日期：",
            value: "organDate",
            type: "date",
            valueFormat: "yyyy-MM-dd",
            required: true,
            disabled: false,
            TimePickerOptions: {
              disabledDate(date) {
                return date.getTime() > Date.now() - 24 * 60 * 60 * 1000; // 此条为设置禁止用户选择今天之后的日期，不包含今天
              }
            },
            rule: {
              required: true,
              message: "请选择发证日期",
              trigger: "blur"
            }
          },
          {
            label: "证书有效期截止日期：",
            value: "endDate",
            type: "date",
            valueFormat: "yyyy-MM-dd",
            disabled: false,
            TimePickerOptions: {
              disabledDate(date) {
                return date.getTime() < Date.now() - 24 * 60 * 60 * 1000; // 此条为设置禁止用户选择今天之前的日期，不包含今天
              }
            }
          },
          {
            label: "承接业务：",
            value: "undertaking",
            type: "textarea",
            width: "100%;",
            class: "formTextarea",
            maxlength: 200,
            tip: "最多可填200个汉字",
            disabled: false
          }
        ]
      },
      {
        title: "企业资质资格信息",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "list",
            class: "formList"
          }
        ]
      },
      {
        title: "备注",
        name: "5",
        icon: "",
        formConfigList: [
          {
            label: "备注信息：",
            value: "description",
            type: "textarea",
            width: "100%;",
            class: "formTextarea",
            maxlength: 300,
            tip: "（最多可填300个汉字）",
            disabled: false
          }
        ]
      },
      {
        title: "其他",
        name: "6",
        icon: "",
        tipsList: [
          { text: "已“通过”的企业信息，如再次提交，须重新进行信息核验，请谨慎操作！" }
        ],
        formConfigList: [
          {
            label: "证书扫描件：",
            type: "slot",
            slotName: "uploadBtn"
          },
          // {
          //   label: "核验记录：",
          //   value: "stateName",
          //   type: "slot",
          //   slotName: "stateName",
          //   disabled: false
          // },
        ]
      },
      {
        title: "免责声明",
        name: "7",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "disclaimer",
            class: "noMargin"
          }
        ]
      }
    ];
  }
}
